import React from 'react'
import { Container } from '@/components/frontend/atoms/layout/Container'
import { Section } from '@/components/frontend/atoms/layout/Section'
import { TwoColumn } from '@/components/frontend/atoms/layout/TwoColumn'
import { HeroPrompt, HeroTitle, HeroAccent, HeroLead } from '@/components/frontend/atoms/layout/Hero'
import { Stack } from '@/components/shared/atoms/layout/Stack'
import { Inline } from '@/components/shared/atoms/layout/Inline'
import { CheckItem } from '@/components/frontend/atoms/content/CheckItem'
import { ButtonLink } from '@/components/frontend/atoms/navigation/ButtonLink'
import { ProfileTerminal } from '@/components/frontend/molecules/ProfileTerminal'
import { useTranslation } from '@/hooks/useTranslation'

const ASSURANCES = ['assurance_call', 'assurance_price', 'assurance_ownership'] as const

export const HeroSection: React.FC = () => {
  const { t, lp } = useTranslation()

  return (
    <Section padding="lg">
      <Container>
        <TwoColumn gap="12" alignItems="center">
          <Stack gap="6" align="start">
            <HeroPrompt>{t('hero.prompt')}</HeroPrompt>
            <HeroTitle>
              {t('hero.title_before')} <HeroAccent>{t('hero.title_accent')}</HeroAccent>{t('hero.title_after')}
            </HeroTitle>
            <HeroLead>{t('hero.subtitle')}</HeroLead>
            <Inline gap="3" wrap>
              <ButtonLink href={lp('/#contatti')} size="lg" arrow>{t('hero.cta_primary')}</ButtonLink>
              <ButtonLink href={lp('/#servizi')} size="lg" variant="secondary">{t('hero.cta_secondary')}</ButtonLink>
            </Inline>
            <Inline gap="6" wrap>
              {ASSURANCES.map((key) => <CheckItem key={key}>{t(`hero.${key}`)}</CheckItem>)}
            </Inline>
          </Stack>
          <ProfileTerminal />
        </TwoColumn>
      </Container>
    </Section>
  )
}
